module.exports = __webpack_public_path__ + "static/media/nublado.7e27c6e8.jpg";